import { useComputed, useSignal } from '@preact/signals'
import { Link } from 'wouter-preact'

import {
	Typography,
	ChevronRightIcon,
	DownArrowIcon,
	UpArrowIcon,
	ViewMoreButton
} from 'components'
import { isProjectLoadingState, projectDetailsState } from 'state'
import { formatDate } from 'utils'

const dataForSmartContractsSkeleton = Array.from({ length: 3 }, (_, i) => ({
	id: i.toString(),
	createdAt: '',
	name: ''
}))

const AllSmartContracts = () => {
	const isShowMoreOpened = useSignal(false)

	const toggleIsOpened = () => {
		isShowMoreOpened.value = !isShowMoreOpened.value
	}

	const dAppsToDisplay = useComputed(() => {
		if (isProjectLoadingState.value) return dataForSmartContractsSkeleton

		if (projectDetailsState.value!.dapps.length > 3) {
			if (isShowMoreOpened.value) {
				return projectDetailsState.value!.dapps
			}
			return projectDetailsState.value!.dapps.slice(0, 3)
		}
		return projectDetailsState.value!.dapps
	})

	return (
		<>
			<Typography
				color='text-black-100'
				text='Your Smart Contracts'
				variant='h4'
			/>

			<div class='mt-6 space-y-4 lg:space-y-2'>
				{dAppsToDisplay.value.map(dapp => (
					<Link
						class='group flex w-full items-center gap-5 rounded-md bg-black-800 p-4'
						href={`/smart-contract/${dapp.name}/workspace`}
						key={dapp.id}
					>
						<div class='flex flex-1 items-center justify-between'>
							<Typography
								class='flex-1 truncate'
								color='text-black-200 group-hover:text-black-100'
								text={dapp.name}
								variant='text2'
							/>
							<div class='flex flex-1 items-center justify-around'>
								<Typography
									class='truncate'
									color='text-black-400'
									text=''
									variant='text4'
								/>
								<Typography
									class='truncate'
									color='text-black-400'
									text={formatDate(dapp.createdAt)}
									variant='text4'
								/>
							</div>
						</div>
						<ChevronRightIcon className='group-hover:text-product' />
					</Link>
				))}
			</div>
			{!isProjectLoadingState.value &&
				projectDetailsState.value!.dapps.length > 3 && (
					<div class='mt-6 flex items-center justify-end'>
						<ViewMoreButton
							icon={
								isShowMoreOpened.value ? (
									<UpArrowIcon className='h-2.5 w-2.5 text-black-200 group-hover:text-product' />
								) : (
									<DownArrowIcon className='h-2.5 w-2.5 text-black-200 group-hover:text-product' />
								)
							}
							onClick={toggleIsOpened}
							text={isShowMoreOpened.value ? 'Show less' : 'Show more'}
							variant='small'
						/>
					</div>
				)}
		</>
	)
}

export { AllSmartContracts }
